import { jsx as l } from "react/jsx-runtime";
const c = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M50.61 27.332c-4.485-.311-8.536.358-12.073 1.997-2.657 1.232-4.436 2.736-6.006 4.062-1.719 1.453-3.204 2.708-5.698 3.658-2.819 1.074-5.973 1.368-9.393.879l-4.432-16.539c3.291.033 6.37-.557 9.182-1.769 3.166-1.364 5.066-3.13 6.743-4.689 1.349-1.255 2.624-2.439 4.497-3.363 3.396-1.674 7.685-1.92 12.761-.733l4.419 16.494 3.86-1.034-5.021-18.741-1.114-.299c-6.526-1.751-12.135-1.505-16.67.73-2.398 1.182-3.95 2.625-5.451 4.021-1.578 1.467-3.07 2.854-5.603 3.946-2.627 1.132-5.572 1.599-8.768 1.396l-1.34-5-3.59 2.038 11.67 43.552 3.585-2.069-3.702-13.805c.711.06 1.413.091 2.107.091 2.715 0 5.287-.457 7.684-1.371 3.13-1.193 5.023-2.793 6.854-4.341 1.511-1.278 2.938-2.484 5.107-3.489 3.263-1.513 7.125-2.018 11.494-1.506l-1.103-4.115.001-.001Z"
      }
    )
  }
);
export {
  c as FlagIssue
};
